<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2" v-if="numericId > 0">Activiteit bewerken</span>
				<span class="pl-2" v-else>Nieuwe activiteit</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-alert v-if="formError" type="error" dense outlined class="mb-4">{{ formError }}</v-alert>
			<v-progress-linear v-if="loading" indeterminate class="mb-4"></v-progress-linear>
			<v-form ref="form" v-model="formValid" v-if="!loading">
				<v-row>
					<v-col cols="12" sm="6">
						<v-select
							dense
							filled
							:items="schoolyears"
							item-text="name"
							item-value="id"
							v-model="form.schoolyear_id"
							label="Schooljaar *"
							:rules="[rules.required]"
						></v-select>
						<v-select
							dense
							filled
							:items="activities"
							item-text="name"
							item-value="id"
							v-model="form.activity_id"
							label="Activiteit *"
							:rules="[rules.required]"
						>
							<template v-slot:selection="{ item }">
								<span class="activity-swatch mr-2" :style="activitySwatchStyle(item)"></span>
								<span>{{ item.name }}</span>
							</template>
							<template v-slot:item="{ item }">
								<span class="activity-swatch mr-2" :style="activitySwatchStyle(item)"></span>
								<span>{{ item.name }}</span>
							</template>
						</v-select>
						<div v-if="selectedActivity" class="mb-4 d-flex align-center">
							<span class="caption mr-2">Kleur:</span>
							<span
								class="activity-swatch activity-swatch--wide"
								:style="activitySwatchStyle(selectedActivity)"
							></span>
						</div>
						<v-text-field
							dense
							filled
							v-model="form.remark"
							label="Opmerking"
						></v-text-field>
						<v-text-field
							dense
							filled
							v-model="form.location"
							label="Locatie"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-menu
							ref="menu_start"
							v-model="menuStart"
							:close-on-content-click="false"
							:return-value.sync="form.start_date"
							transition="scale-transition"
							offset-y
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="form.start_date"
									label="Startdatum *"
									prepend-inner-icon="mdi-calendar"
									readonly
									v-on="on"
									filled
									dense
									:rules="[rules.required]"
								></v-text-field>
							</template>
							<v-date-picker v-model="form.start_date" no-title scrollable>
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="menuStart = false">Annuleren</v-btn>
								<v-btn text color="primary" @click="$refs.menu_start.save(form.start_date)">
									OK
								</v-btn>
							</v-date-picker>
						</v-menu>

						<v-menu
							ref="menu_end"
							v-model="menuEnd"
							:close-on-content-click="false"
							:return-value.sync="form.end_date"
							transition="scale-transition"
							offset-y
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="form.end_date"
									label="Einddatum *"
									prepend-inner-icon="mdi-calendar"
									readonly
									v-on="on"
									filled
									dense
									:rules="[rules.required, rules.endAfterStart]"
								></v-text-field>
							</template>
							<v-date-picker v-model="form.end_date" no-title scrollable :min="form.start_date || undefined">
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="menuEnd = false">Annuleren</v-btn>
								<v-btn text color="primary" @click="$refs.menu_end.save(form.end_date)">
									OK
								</v-btn>
							</v-date-picker>
						</v-menu>

						<v-row>
							<v-col cols="12" sm="6">
								<v-menu
									ref="menu_start_time"
									v-model="menuStartTime"
									:close-on-content-click="false"
									:return-value.sync="form.start_time"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="form.start_time"
											label="Starttijd"
											prepend-inner-icon="mdi-clock-outline"
											readonly
											clearable
											v-on="on"
											filled
											dense
										></v-text-field>
									</template>
									<v-time-picker
										v-if="menuStartTime"
										v-model="form.start_time"
										format="24hr"
										full-width
									>
										<v-spacer></v-spacer>
										<v-btn text color="primary" @click="menuStartTime = false">
											Annuleren
										</v-btn>
										<v-btn
											text
											color="primary"
											@click="$refs.menu_start_time.save(form.start_time)"
										>
											OK
										</v-btn>
									</v-time-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" sm="6">
								<v-menu
									ref="menu_end_time"
									v-model="menuEndTime"
									:close-on-content-click="false"
									:return-value.sync="form.end_time"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="form.end_time"
											label="Eindtijd"
											prepend-inner-icon="mdi-clock-outline"
											readonly
											clearable
											v-on="on"
											filled
											dense
											:rules="[rules.endTimeAfterStart]"
										></v-text-field>
									</template>
									<v-time-picker
										v-if="menuEndTime"
										v-model="form.end_time"
										format="24hr"
										full-width
									>
										<v-spacer></v-spacer>
										<v-btn text color="primary" @click="menuEndTime = false">
											Annuleren
										</v-btn>
										<v-btn
											text
											color="primary"
											@click="$refs.menu_end_time.save(form.end_time)"
										>
											OK
										</v-btn>
									</v-time-picker>
								</v-menu>
							</v-col>
						</v-row>

						<v-alert v-if="periodHint" type="info" dense outlined class="mt-2 mb-0">
							{{ periodHint }}
						</v-alert>
					</v-col>
					<v-col cols="12">
						<p class="body-2 font-weight-medium mb-2">Activiteitsinformatie</p>
						<rich-text-editor
							v-model="form.activity_information"
							placeholder="Voer uitgebreide informatie over de activiteit in..."
						></rich-text-editor>
						<p class="caption text--secondary mt-1 mb-0">
							Optioneel. Gebruik de werkbalk voor opmaak, lijsten en links.
						</p>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn color="primary" depressed :loading="saving" :disabled="loading" @click="submit">
				Opslaan
			</v-btn>
			<v-btn color="dark" depressed @click="$router.go(-1)">Annuleren</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";
import { activitySwatchStyle } from "../../constants/schoolyearPlanningActivities";
import { SCHOOLYEAR_PERIODS, parseSchoolyearYears } from "../../constants/schoolyearPeriods";
import RichTextEditor from "../../components/RichTextEditor";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "SchoolyearPlanningAddEdit",
	props: ["id"],
	components: {
		RichTextEditor
	},
	data() {
		var self = this;
		return {
			formValid: false,
			loading: false,
			saving: false,
			formError: "",
			menuStart: false,
			menuEnd: false,
			menuStartTime: false,
			menuEndTime: false,
			schoolyears: [],
			activities: [],
			form: {
				schoolyear_id: null,
				activity_id: null,
				start_date: null,
				end_date: null,
				start_time: null,
				end_time: null,
				location: "",
				activity_information: "",
				remark: ""
			},
			rules: {
				required: function(v) {
					return (v != null && String(v).trim() !== "") || "Verplicht veld";
				},
				endAfterStart: function(v) {
					if (!v || !self.form.start_date) return true;
					return (
						String(v) >= String(self.form.start_date) ||
						"Einddatum mag niet vóór de startdatum liggen"
					);
				},
				endTimeAfterStart: function(v) {
					if (
						!v ||
						!self.form.start_time ||
						self.form.start_date !== self.form.end_date
					) {
						return true;
					}
					return (
						String(v) >= String(self.form.start_time) ||
						"Eindtijd mag op dezelfde datum niet vóór de starttijd liggen"
					);
				}
			}
		};
	},
	computed: {
		numericId() {
			var n = Number(this.id);
			return Number.isNaN(n) ? 0 : n;
		},
		selectedActivity() {
			var id = this.form.activity_id;
			if (id == null) return null;
			return (this.activities || []).find(function(a) {
				return Number(a.id) === Number(id);
			});
		},
		selectedSchoolyear() {
			var id = this.form.schoolyear_id;
			if (id == null) return null;
			return (this.schoolyears || []).find(function(s) {
				return Number(s.id) === Number(id);
			});
		},
		periodHint() {
			if (!this.form.start_date || !this.selectedSchoolyear) return "";
			var d = String(this.form.start_date);
			var parts = d.split("-");
			if (parts.length < 2) return "";
			var month = Number(parts[1]);
			var year = Number(parts[0]);
			var years = parseSchoolyearYears(this.selectedSchoolyear.name || "");
			var match = SCHOOLYEAR_PERIODS.find(function(p) {
				return p.months.indexOf(month) !== -1;
			});
			if (!match) {
				return "Deze datum valt buiten de vaste schooljaarperiodes (juli of onbekend).";
			}
			var calYear =
				years.startYear != null
					? match.year_offset === 0
						? years.startYear
						: years.endYear
					: year;
			return match.name + " — " + match.label_nl + (calYear ? " " + calYear : "");
		}
	},
	created() {
		this.bootstrap();
	},
	methods: {
		activitySwatchStyle: activitySwatchStyle,
		bootstrap() {
			var self = this;
			self.loading = true;
			self.formError = "";
			Promise.all([
				ax.get("/schoolyear/all"),
				ax.get("/schoolyear_planning/activities")
			])
				.then(function(results) {
					self.schoolyears = Array.isArray(results[0].data) ? results[0].data : [];
					self.activities = Array.isArray(results[1].data) ? results[1].data : [];
					if (self.numericId > 0) {
						return self.fetchRecord();
					}
					var qSy = self.$route.query && self.$route.query.schoolyear_id;
					var queryId = qSy != null && qSy !== "" ? Number(qSy) : null;
					var queryIsActive =
						queryId != null &&
						self.schoolyears.some(function(s) {
							return Number(s.id) === queryId;
						});
					if (queryIsActive) {
						self.form.schoolyear_id = queryId;
					} else if (self.schoolyears.length > 0) {
						self.form.schoolyear_id = self.schoolyears[0].id;
					}
				})
				.catch(function() {
					self.formError = "Gegevens konden niet worden geladen.";
				})
				.finally(function() {
					if (self.numericId === 0) {
						self.loading = false;
					}
				});
		},
		fetchRecord() {
			var self = this;
			return ax
				.get("/schoolyear_planning/single/" + self.numericId)
				.then(function(res) {
					var row = res.data || {};
					var schoolyearId = row.schoolyear_id;
					var isActive =
						schoolyearId != null &&
						self.schoolyears.some(function(s) {
							return Number(s.id) === Number(schoolyearId);
						});
					if (!isActive && self.schoolyears.length > 0) {
						schoolyearId = self.schoolyears[0].id;
					}
					self.form = {
						schoolyear_id: schoolyearId,
						activity_id: row.activity_id,
						start_date: self.normalizeDate(row.start_date),
						end_date: self.normalizeDate(row.end_date),
						start_time: self.normalizeTime(row.start_time),
						end_time: self.normalizeTime(row.end_time),
						location: row.location || "",
						activity_information: row.activity_information || "",
						remark: row.remark || ""
					};
				})
				.catch(function() {
					self.formError = "Record kon niet worden geladen.";
				})
				.finally(function() {
					self.loading = false;
				});
		},
		normalizeDate(value) {
			if (!value) return null;
			var s = String(value);
			return s.length >= 10 ? s.slice(0, 10) : s;
		},
		normalizeTime(value) {
			if (!value) return null;
			return String(value).slice(0, 5);
		},
		submit() {
			var self = this;
			if (self.$refs.form && !self.$refs.form.validate()) {
				return;
			}
			self.saving = true;
			self.formError = "";
			var payload = {
				schoolyear_id: self.form.schoolyear_id,
				activity_id: self.form.activity_id,
				start_date: self.form.start_date,
				end_date: self.form.end_date,
				start_time: self.form.start_time || null,
				end_time: self.form.end_time || null,
				location: self.form.location || null,
				activity_information: self.form.activity_information || null,
				remark: self.form.remark || null
			};
			var req =
				self.numericId > 0
					? ax.post("/schoolyear_planning/update/" + self.numericId, payload)
					: ax.post("/schoolyear_planning/create", payload);
			req
				.then(function() {
					self.$router.push({ path: "/schooladmin/schoolyear_planning" });
				})
				.catch(function(err) {
					self.formError =
						(err &&
							err.response &&
							err.response.data &&
							err.response.data.msg) ||
						"Opslaan mislukt.";
				})
				.finally(function() {
					self.saving = false;
				});
		}
	}
};
</script>

<style scoped>
.activity-swatch {
	display: inline-block;
	width: 28px;
	height: 18px;
	border-radius: 2px;
	vertical-align: middle;
}
.activity-swatch--wide {
	width: 72px;
	height: 22px;
}
</style>
